import React from 'react'
import './Footer.css'

// Assets
import fnn_logo from './img/FNNLogoWithWhiteFont-07.png'

// Icons
import { BsFillTelephoneFill } from "react-icons/bs";
import { MdEmail } from "react-icons/md";
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import {
    faLinkedin,
    faXTwitter,
    faYoutube,
} from '@fortawesome/free-brands-svg-icons';

const Footer = () => {

    const goTo = (path: string) => {
        window.location.href = path;
    };

    return (
        <div className='footer-wrapper'>
            <div className='footer-left'>
                <div className='footer-info'>
                    <div className="footer-card">
                        <h1>PLATFORM</h1>
                        <p onClick={() => goTo('/hrl-detector')}>HRL Detector</p>
                        <p onClick={() => goTo('/utility')}>Utility Solutions</p>
                        <p onClick={() => goTo('/fire-agency')}>Fire Agency Solutions</p>
                        <p onClick={() => goTo('/contact')}>Contact Us</p>
                    </div>

                    <div className='footer-card'>
                        <h1>HEADQUARTERS</h1>
                        <p onClick={() => goTo('/contact')}>747 SW 2nd Avenue <br />
                            Suite 169 <br />
                            Gainesville, FL 32601 <br />
                            United States of America</p>

                    </div>

                    <div className='footer-card'>
                        <h1>SOCIAL MEDIA</h1>
                        <a
                            href="https://www.youtube.com/@FNN_INC/videos"
                            target="_blank"
                            rel="noopener noreferrer"
                        >
                            <p>YouTube</p>
                        </a>

                        <a
                            href="https://www.linkedin.com/company/fnninc/"
                            target="_blank"
                            rel="noopener noreferrer"
                        >
                            <p>LinkedIn</p>
                        </a>
                        <a
                            href="https://x.com/_FNNINC"
                            target="_blank"
                            rel="noopener noreferrer"
                        >
                            <p>X</p>
                        </a>
                    </div>

                    <div className='footer-card'>
                        <h1>DISCOVER</h1>
                        <p onClick={() => goTo('/about')}>About</p>
                        <p onClick={() => goTo('/news')}>News</p>
                        <p onClick={() => goTo('/careers')}>Careers</p>
                        <p onClick={() => goTo('/fountainn')}>FountaiNN</p>
                        <p onClick={() => goTo('/login')}>Portal</p>
                    </div>

                </div>

                <div className='footer-terms-wrapper'>
                    <p className='copyright-text'>© {new Date().getFullYear()} Helios Pompano Inc. dba FNN® </p>
                    <p onClick={() => goTo('/privacy_policy')}>Privacy Policy</p>
                    <p onClick={() => goTo('/terms_of_service')}>Terms of Service</p>
                    <p onClick={() => goTo('/cookie_policy')}>Cookie Policy</p>
                </div>


            </div>

            <div className='footer-right'>

                <div className='footer-right-info'>

                    <a href="/">
                        <img className="fnn-logo" alt="hero background" src={fnn_logo} />
                    </a>

                    <div className='footer-contact'>
                        <p><BsFillTelephoneFill />+1 (954)-681-1770 </p>
                        <p><MdEmail style={{ width: '1.2rem', height: '1.2rem' }} />team@fireneuralnetwork.com</p>
                    </div>
                </div>


                <div className='footer-social-media'>

                    <a
                        href="https://www.youtube.com/@FNN_INC/videos"
                        className="text-gray-200 hover:text-white"
                        target="_blank"
                        rel="noopener noreferrer"
                    >
                        <FontAwesomeIcon icon={faYoutube} size="2x" />
                    </a>

                    <a
                        href="https://www.linkedin.com/company/fnninc/"
                        className="text-gray-200 hover:text-white"
                        target="_blank"
                        rel="noopener noreferrer"
                    >
                        <FontAwesomeIcon icon={faLinkedin} size="2x" />
                    </a>

                    <a
                        href="https://x.com/_FNNINC"
                        className="text-gray-200 hover:text-white"
                        target="_blank"
                        rel="noopener noreferrer"
                    >
                        <FontAwesomeIcon icon={faXTwitter} size="2x" />
                    </a>

                </div>

            </div>

            <div className='footer-terms-wrapper2'>
                <p className='copyright-text2'>© {new Date().getFullYear()} Helios Pompano Inc. dba FNN® </p>

                <div className='footer-terms-links2'>
                    <p onClick={() => goTo('/privacy_policy')}>Privacy Policy</p>
                    <p onClick={() => goTo('/terms_of_service')}>Terms of Service</p>
                    <p onClick={() => goTo('/cookie_policy')}>Cookie Policy</p>
                </div>
            </div>

        </div>
    )
}

export default Footer